import { render, staticRenderFns } from "./DynamicList.vue?vue&type=template&id=575962f6"
import script from "./DynamicList.vue?vue&type=script&lang=js"
export * from "./DynamicList.vue?vue&type=script&lang=js"
import style0 from "./DynamicList.vue?vue&type=style&index=0&id=575962f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports